import React                        from 'react';
import { Grid, Group, Text, Title } from '@mantine/core';
import { CSection }                 from '@core/components/common/CSection';
import { CImage }                   from '@core/components/common/CImage';
import { LinkButton }               from '@core/components/common/LinkButton';
import { AppRoutes }                from '@core/router/AppRoutes';
import useDxbTheme                  from '@hooks/use-dxb-theme';
import useStyles                    from './ThingsToKnowSection.styles';


interface Item {
    label: string;
    icon: string;
    route?: string;
}

export const ThingsToKnowSection: React.FC = () => {

    const { classes } = useStyles();
    const { isLight } = useDxbTheme();

    const listHouseRulesData: Item[] = [
        { label: 'Check-in: 3:00 PM.', icon: `${isLight ? '/icons/clock-light.svg' : '/icons/clock-dark.svg'}` },
        { label: 'Check-out: 12:00 PM.', icon: `${isLight ? '/icons/clock-light.svg' : '/icons/clock-dark.svg'}` },
        { label: 'Self check-in.', icon: `${isLight ? '/icons/key-light.svg' : '/icons/key-dark.svg'}` },
        { label: 'No smoking.', icon: `${isLight ? '/icons/no-smoking-light.svg' : '/icons/no-smoking-dark.svg'}` },
        { label: 'Pets are not allowed.', icon: `${isLight ? '/icons/no-pets-light.svg' : '/icons/no-pets-dark.svg'}` }
    ];

    const listHouseRulesItems = listHouseRulesData.map((item) => {

        return (
            <Group mb={14} mt={14} key={item.label} spacing="xs">
                <CImage width={18} height={18} src={item.icon} alt={item.label}/>
                <Text ml={4} size={12}>{item.label}</Text>
            </Group>
        )
    });

    const listHealthSafetyData: Item[] = [
        { label: 'Committed to enhanced cleaning process.', icon: `${isLight ? '/icons/verified-light.svg' : '/icons/verified-dark.svg'}` },
        { label: 'Sanitized before every check in.', icon: `${isLight ? '/icons/sanitized-light.svg' : '/icons/sanitized-dark.svg'}` },
        { label: 'Emergency first-aid kit.', icon: `${isLight ? '/icons/first-aid-light.svg' : '/icons/first-aid-dark.svg'}` },
        { label: 'Smoke alarm.', icon: `${isLight ? '/icons/smoke-alarm-light.svg' : '/icons/smoke-alarm-dark.svg'}` }
    ];

    const listHealthSafetyItems = listHealthSafetyData.map((item) => {

        return (
            <Group mb={14} mt={14} key={item.label} spacing="xs">
                <CImage width={18} height={18} src={item.icon} alt={item.label}/>
                <Text ml={4} size={12}>{item.label}</Text>
            </Group>
        )
    });

    const listPoliciesData: Item[] = [
        { label: 'Terms and Conditions', route: AppRoutes.TERMS, icon: `${isLight ? '/icons/link-right-light.svg' : '/icons/link-right-dark.svg'}` },
        { label: 'House and refund policies', route: AppRoutes.POLICIES, icon: `${isLight ? '/icons/link-right-light.svg' : '/icons/link-right-dark.svg'}` },
        { label: 'Contact us', route: AppRoutes.CONTACT, icon: `${isLight ? '/icons/link-right-light.svg' : '/icons/link-right-dark.svg'}` }
    ];

    const listPoliciesItems = listPoliciesData.map((item) => {
        return (
            <Group className={classes.links} mb={14} mt={14} key={item.label} spacing="xs">
                <CImage width={18} height={18} src={item.icon} alt={item.label}/>
                <LinkButton title={item.label} route={item.route}/>
            </Group>
        )
    });

    return (
        <CSection
            // className={} to control content div only
            // change heading styling in the component itself.
            heading="Things you need to know"
            content={
                <Grid>

                    <Grid.Col sm={3} md={4}>
                        <Title mb={20} className={classes.h3} order={3}>House Rules</Title>
                        {listHouseRulesItems}
                    </Grid.Col>

                    <Grid.Col className={classes.thingsGridCol} sm={5} md={4}>
                        <Title mb={20} className={classes.h3} order={3}>Health & Safety</Title>
                        {listHealthSafetyItems}
                    </Grid.Col>

                    <Grid.Col className={classes.thingsGridCol} sm={4} md={4}>
                        <Title mb={20} className={classes.h3} order={3}>Detailed Policies</Title>
                        <Text size={14} mb={20}>If you have any questions feel free to contact us.</Text>
                        {listPoliciesItems}
                    </Grid.Col>

                </Grid>
            }
        />
    )

};
